import { Link } from 'react-router-dom';

export default function HeroBanner() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20cinematic%20dark%20atmosphere%20with%20movie%20theater%20elements%2C%20warm%20golden%20stage%20curtains%2C%20soft%20dramatic%20lighting%2C%20abstract%20film%20reel%20textures%2C%20elegant%20dark%20background%20with%20subtle%20warm%20highlights%2C%20cinematic%20aesthetic%2C%20no%20people%2C%20no%20text&width=1920&height=1080&seq=hero-cinema-bg&orientation=landscape"
        alt="嫩草影院 - 高清影视在线观看平台"
        title="嫩草影院 - 高清影视在线观看平台"
        className="w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background-950/60 via-background-950/30 to-background-950/90" />

      <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4 md:px-6 w-full">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-50 font-heading mb-4 leading-tight">
          海量高清影视
          <span className="block text-primary-400 mt-2">随时随地 免费畅享</span>
        </h1>
        <p className="text-sm md:text-lg text-foreground-300 max-w-2xl mb-8 leading-relaxed">
          嫩草影院汇聚全网最新电影、热播电视剧、热门动漫、精彩综艺和高分纪录片，
          无需注册，即点即看，让优质影视内容触手可及
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/dianying"
            className="px-8 py-3 rounded-lg bg-primary-500 hover:bg-primary-600 text-background-950 font-semibold text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <span className="flex items-center gap-2">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-play-circle-fill text-base"></i>
              </div>
              开始观影
            </span>
          </Link>
          <Link
            to="/category/dianshiju"
            className="px-8 py-3 rounded-lg border border-foreground-300/40 hover:border-primary-400/60 text-foreground-200 hover:text-primary-400 text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            热门剧集
          </Link>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2">
        <div className="w-6 h-10 flex items-center justify-center animate-bounce">
          <i className="ri-arrow-down-s-line text-foreground-400 text-xl"></i>
        </div>
      </div>
    </section>
  );
}